import Develop from "pages/Develop";

const Home = () => {
  return <Develop />;
};

export default Home;
